/**
 * 商品基础信息登录 api
 */
import Vue from "vue";
import axios from '@/utils/http';
import axiosExample from 'axios';
const api = {
  //商品基础信息查询-初始化模板结构接口
  inittemplate() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/itemquery/inittemplate`, {
      mask:false,
    });
  },
  //商品基础信息查询-列表数据查询
  search(_param) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/itemquery/s-grid`, {
      mask:false,
      params: _param
    });
  },
  //商品基础信息查询-供应商数据确认操作
  edit(_param) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/itemquery/s-edit`, {
      mask:false,
      params: _param
    });
  },
}

export default api;



// WEBPACK FOOTER //
// ./src/api/itemQuery.js